var map = {
	"./business.svg": "f0b3",
	"./call.svg": "5999",
	"./call_end.svg": "598a",
	"./call_made.svg": "fd39",
	"./call_merge.svg": "0bc6",
	"./call_missed.svg": "db61",
	"./call_missed_outgoing.svg": "2310",
	"./call_received.svg": "df0b",
	"./call_split.svg": "fdc0",
	"./chat.svg": "0052",
	"./chat_bubble.svg": "460c",
	"./chat_bubble_outline.svg": "82f7",
	"./clear_all.svg": "4621",
	"./comment.svg": "5342",
	"./contact_mail.svg": "fb24",
	"./contact_phone.svg": "a540",
	"./contacts.svg": "58a0",
	"./dialer_sip.svg": "d1dc",
	"./dialpad.svg": "dd2f",
	"./email.svg": "9e2f",
	"./forum.svg": "366d",
	"./import_contacts.svg": "e0c7",
	"./import_export.svg": "13b4",
	"./invert_colors_off.svg": "abd5",
	"./live_help.svg": "e3ee",
	"./location_off.svg": "7eb5",
	"./location_on.svg": "64de",
	"./mail_outline.svg": "4b33",
	"./message.svg": "16dc",
	"./no_sim.svg": "1ee9",
	"./phone.svg": "105f",
	"./phonelink_erase.svg": "2173",
	"./phonelink_lock.svg": "2e00",
	"./phonelink_ring.svg": "9913",
	"./phonelink_setup.svg": "4d62",
	"./portable_wifi_off.svg": "1c8a",
	"./present_to_all.svg": "cf2e",
	"./ring_volume.svg": "6481",
	"./rss_feed.svg": "dd1f",
	"./screen_share.svg": "82e1",
	"./speaker_phone.svg": "fb37",
	"./stay_current_landscape.svg": "2489",
	"./stay_current_portrait.svg": "fd59",
	"./stay_primary_landscape.svg": "d326",
	"./stay_primary_portrait.svg": "5a09",
	"./stop_screen_share.svg": "6b0d",
	"./swap_calls.svg": "c233",
	"./textsms.svg": "8ce9",
	"./voicemail.svg": "d906",
	"./vpn_key.svg": "ff62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d996";